export default __webpack_public_path__ + "static/media/home-popup.fb7c55ce.png";